import { Radio, RadioProps } from "@mui/material";

import { CheckedIcon, UncheckedIcon } from "./icons";

export function StyledRadio(props: RadioProps) {
  return (
    <Radio checkedIcon={<CheckedIcon />} icon={<UncheckedIcon />} {...props} />
  );
}
